import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { getAlertType } from '../../../helpers/alerts';
import { hideNotification } from '../../../store/actions/notification';

const FieldMessagesComponent = (props) => {
  const [showFlag, setShowFlag] = useState(false)

  useEffect(() => {
    setShowFlag(showErrorMessage(props))
  }, [props])

  const showErrorMessage = (props) => {
    if (props.showFlag) {
      return true;
    }

    const { formikProps, message } = props;
    let show = false;

    if (formikProps && formikProps.touched && formikProps.errors) {
      for (let key in formikProps.touched) {
        if (formikProps.touched.hasOwnProperty(key) && formikProps.errors.hasOwnProperty(key)) {
          show = (show || !!(formikProps.touched[key] && formikProps.errors[key]));
        }
      }
    }

    if(message !== null && formikProps.errors[props.name] === undefined) {
      show = false;
    }

    return show;
  }

  const onDismiss = () => {
    const { formikProps, hideNotification, onClose } = props;

    if (typeof formikProps !== 'undefined') {
      formikProps.setErrors({});
    }

    if (typeof hideNotification === 'function') {
      hideNotification();
    }

    if (typeof onClose === 'function') {
      onClose();
    }
  }

  const showFieldError = (prop) => {
    if (msgs && msgs[prop] && Array.isArray(msgs[prop])) {
      return <div className={ !props.addMargin ? 'no-input-margin' : '' }> { Object.values(msgs[prop]) }</div>
    }
  }

  const { notificationId, id, ownProps, customMessage, showDismiss } = props;
  let { message, type, color } = props;

  if (ownProps && type !== ownProps.type && showFlag) {
    message = null;
  }

  let msgs = message || customMessage;

  if (
    !(showFlag || (msgs && notificationId === id)) &&
    !(Array.isArray(notificationId) && notificationId.includes(id))
  ) 
    return null;

  if (ownProps && ownProps.showFlag) {
    msgs = customMessage || '';
  }

  if (ownProps && ownProps.type) {
    type = ownProps.type;
  }

  if (!color) {
    color = getAlertType(type)
  }

  return (
    <Alert
      color={ color }
      className={`text-center ${props.class ? props.class : ''}`}
      id="errors-container"
      toggle={ showDismiss ? onDismiss : null }
    >
      {
        props.name &&
        showFieldError(props.name)
      }
      {
        props.errorname &&
        showFieldError(props.errorname)
      }
      {
        props.handleErrorChange && typeof props.handleErrorChange === "function" && props.handleErrorChange(true)
      }
      { props.children }
    </Alert>
  );
}

FieldMessagesComponent.defaultProps = {
  showFlag: false,
  notificationId: null,
  id: null,
  customMessage: '',
  showDismiss: true,
  addMargin: false,
};

const mapStateToProps = (state, ownProps) => ({
  message: state.notification.message,
  type: state.notification.type,
  id: state.notification.notificationId,
  ownProps: ownProps,
});

const mapActionsToProps = {
  hideNotification,
};

const FieldMessages = connect(mapStateToProps, mapActionsToProps)(FieldMessagesComponent);

export { FieldMessages, FieldMessagesComponent };
